import Vue from 'vue';
import { DataService } from '../../data.service';

const chartID = 'getCountyNonCoreForestedAreaChange';
/**
 * Tab 3: Forests: Percent Net Decrease In Forested Wetland Area
 * getCountyNonCoreForestedAreaChange
 */
export class Tab3Chart4 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    updateChartData(response) {
        this.chart.value = +(parseFloat(response.value).toFixed(2));
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Percent Net Decrease In Forested Wetland Area',
                        loading: true
                    },
                    value: 0.0
                }
            },
            computed: {
                direction: function () {
                    if (this.value < 0) return 'down';
                    else return 'up';
                },
                color: () => {
                    return {
                        color: "#9BBB59" //green
                    };
                }
            }
        });
        //end vue component
    }
}
